if (!customElements.get('product-hotspot')) {
  customElements.define(
    'product-hotspot',
    class ProductHotspot extends HTMLElement {
      constructor() {
        super();

        this.hotspotId = this.getAttribute('id');

        /** @type {HTMLButtonElement | null} */
        this.button = this.querySelector('[data-product-hotspot-button]');

        /** @type {HTMLDivElement | null} */
        this.modal = document.querySelector(`[data-focus-trap="${this.hotspotId}"]`);

        /** @type {(() => void) | null} */
        this.cleanupAutoUpdate = null;

        /** @type {IntersectionObserver | null} */
        this.intersectionObserver = null;
      }

      connectedCallback() {
        window.addEventListener('modal-trap-activate', this.handleModalActivate);
      }

      disconnectedCallback() {
        window.removeEventListener('modal-trap-activate', this.handleModalActivate);
        this.stopAutoUpdatingPosition();
      }

      handleModalActivate = (/** @type {{ detail: { id: string } }} */ e) => {
        if (e.detail.id === this.hotspotId) {
          this.startAutoUpdatingPosition();
        }
      };

      updateModalPosition = () => {
        const { computePosition, offset, shift } = window.floatingUi;

        if (!this.button || !this.modal) return;

        computePosition(this.button, this.modal, {
          middleware: [offset(4), shift({ padding: 16 })],
        }).then(({ x, y }) => {
          if (!this.modal) return;

          Object.assign(this.modal.style, {
            left: `${x}px`,
            top: `${y}px`,
          });
        });
      };

      startAutoUpdatingPosition() {
        this.stopAutoUpdatingPosition();

        const { autoUpdate } = window.floatingUi;

        if (!this.button || !this.modal || !autoUpdate) return;

        this.updateModalPosition();

        this.cleanupAutoUpdate = autoUpdate(this.button, this.modal, this.updateModalPosition);

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => !entry.isIntersecting)) {
              const modalTrapElement = this.modal?.closest('modal-trap');
              if (
                modalTrapElement &&
                'trap' in modalTrapElement &&
                modalTrapElement.trap &&
                typeof modalTrapElement.trap === 'object' &&
                'deactivate' in modalTrapElement.trap &&
                typeof modalTrapElement.trap.deactivate === 'function'
              ) {
                modalTrapElement.trap.deactivate();
              }
            }
          },
          { threshold: 1 },
        );

        this.intersectionObserver.observe(this.button);
      }

      stopAutoUpdatingPosition() {
        if (this.cleanupAutoUpdate) {
          this.cleanupAutoUpdate();
          this.cleanupAutoUpdate = null;
        }

        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
          this.intersectionObserver = null;
        }
      }
    },
  );
}
